// extracted by mini-css-extract-plugin
export default {"card":"E3-z"};